import { SetStateAction, useEffect, useRef, useState } from 'react';
import ReactPlayer from 'react-player';
import MuteIcon from '../../../assets/Controls/MuteIcon';
import PauseIcon from '../../../assets/Controls/PauseIcon';
import PlayIcon from '../../../assets/Controls/PlayIcon';
import VolumeIcon from '../../../assets/Controls/VolumeIcon';
import { normalizeHeight } from '../../../utils/normalize';
import { BottomContainer, ButtonsContainer, Container, ControlButtonWrapper, LocalBottomContainer, LocalProgressContainer, ProgressContainer, VideoContainer } from './styles';

type SnipzPlayerProps = {
  modal: boolean;
  isFeed: boolean;
  local: boolean;
  src?: any;
  isCurrent?: boolean;
  setPlaying?: any;
}

export default function SnipzPlayer({ local, src, isFeed, modal, isCurrent }: SnipzPlayerProps) {
  const [isMuted, setIsMuted] = useState(true);
  const [isPlaying, setIsPlaying] = useState(false);
  const [played, setPlayed] = useState(0);
  const playerRef = useRef<any>(null);
  const previewRef = useRef<any>(null);

  const handlePlayPause = () => {
    if (local) {
      if (isPlaying) {
        previewRef.current.pause();
      } else {
        previewRef.current.play();
      }
    }
    setIsPlaying(!isPlaying);
  };

  const handleMute = () => {
    setIsMuted(!isMuted);
  };

  const handleProgress = (state: { loaded: any; played: SetStateAction<number>; }) => {
    if (!state.loaded || !state.played) return;
    setPlayed(state.played);
  };

  const handleSeek = (e: any) => {
    if (local) {
      const progressBar = e.target;
      const newTime = (e.nativeEvent.offsetX / progressBar.clientWidth) * previewRef.current.duration;
      previewRef.current.currentTime = newTime;
    } else {
      const clickedTime = (e.nativeEvent.offsetX / e.target.offsetWidth) * playerRef.current.getDuration();
      playerRef.current.seekTo(clickedTime);
    }
  };

  const handleTimeUpdate = () => {
    const currentProgress = (previewRef.current.currentTime / previewRef.current.duration);
    setPlayed(currentProgress);
  };

  useEffect(() => {
    if (!local) return;
    const video = previewRef.current;
    video.addEventListener('timeupdate', handleTimeUpdate);

    return () => {
      video.removeEventListener('timeupdate', handleTimeUpdate);
    };
  }, [local]);

  const handleMouseOver = (e: boolean) => {
    if (isFeed && !modal) {
      setIsPlaying(e);
    }
  }

  useEffect(() => {
    if (!isFeed && !modal && isCurrent) {
      setIsPlaying(true);
      setIsMuted(false);
    } else {
      setIsPlaying(false);
      setIsMuted(true);
    }
  }, [isFeed, modal, isCurrent])

  return (
    <Container>
      <VideoContainer onMouseOver={() => handleMouseOver(true)} onMouseOut={() => handleMouseOver(false)}>
        {local ?
          <video
            ref={previewRef}
            controls={false}
            width="320px"
            height="569px"
            autoPlay={isPlaying}
            loop={true}
            muted={isMuted}
            style={{ objectFit: 'contain', borderRadius: 8, overflow: 'hidden' }}
          >
            <source src={src} type='video/mp4' />
          </video>
          :
          <ReactPlayer
            height={isFeed ? '100%' : normalizeHeight(790)}
            // light={true}
            playing={isPlaying}
            controls={false}
            volume={0.8}
            style={{ borderRadius: 8, overflow: 'hidden', objectFit: 'contain' }}
            width={isFeed ? '400px' : '427px'}
            url={src}
            muted={isMuted}
            onProgress={handleProgress}
            ref={playerRef}
          />
        }
      </VideoContainer>
      {local ? (
        <LocalBottomContainer>
          <ButtonsContainer>
            <ControlButtonWrapper onClick={() => handlePlayPause()}>
              {isPlaying ? <PauseIcon /> : <PlayIcon />}
            </ControlButtonWrapper>
            <ControlButtonWrapper onClick={() => handleMute()}>
              {isMuted ? <MuteIcon /> : <VolumeIcon />}
            </ControlButtonWrapper>
          </ButtonsContainer>
          <LocalProgressContainer
            onClick={(e) => handleSeek(e)}>
            <div
              style={{
                height: '6px',
                backgroundColor: '#999999',
                width: '100%',
                position: 'relative',
                borderRadius: 8
              }}
            >
              <div
                style={{
                  height: '100%',
                  backgroundColor: '#F33333',
                  width: `${played * 100}%`,
                  borderRadius: 8
                }}
              />
            </div>
          </LocalProgressContainer>
        </LocalBottomContainer>
      ) : (
        <>
          {(modal || !isFeed) && (
            <BottomContainer>
              <ButtonsContainer>
                <ControlButtonWrapper onClick={() => handlePlayPause()}>{isPlaying ? <PauseIcon /> : <PlayIcon />}</ControlButtonWrapper>
                <ControlButtonWrapper onClick={() => handleMute()}>{isMuted ? <MuteIcon /> : <VolumeIcon />}</ControlButtonWrapper>
              </ButtonsContainer>
              <ProgressContainer
                onClick={(e) => handleSeek(e)}
                style={{ width: isFeed ? '350px' : '380px' }}
              >
                <div
                  style={{
                    height: '6px',
                    backgroundColor: '#999999',
                    width: '100%',
                    position: 'relative',
                    borderRadius: 8
                  }}
                >
                  <div
                    style={{
                      height: '100%',
                      backgroundColor: '#F33333',
                      width: `${played * 100}%`,
                      borderRadius: 8
                    }}
                  />
                </div>
              </ProgressContainer>
            </BottomContainer>
          )}
        </>
      )}
    </Container>
  )
}